







import { Component, Prop, Vue } from 'vue-property-decorator';

import * as def from '@/definitions'
import { Layer } from '@/model/document2/page/surface/design/layer/layer';
import { Vector2 } from '@/utilityModels/vector2';
import { TextLayer } from '@/model/document2/page/surface/design/layer/textLayer';
import { MathHelper } from '@/helper/mathHelper';

import { UserAgentHelper } from "@/helper/userAgentHelper"

@Component({
    components: {
    },
})
export default class TextEditor extends Vue 
{
    @Prop() private layer! : TextLayer;
    // designScale -> SvgView
    @Prop() private scale! : number;
    // SvgView -> Html(px)
    @Prop() private scaleFromSvg! : number;
    // SvgViewSize
    @Prop() private offsetX! : number;
    @Prop() private offsetY! : number;
    // 縦書きかどうか
    @Prop({default : false}) private isVertical! : boolean;

    // エディタでフォーカスをロックする。trueの間は他の入力にフォーカスが渡らない
    private isFocusLock : boolean = true;

    private changeInputMode(mode)
    {
        this.$store.dispatch("changeInputMode", mode);
    }

    mounted() 
    {
        this.focus();
        
        // メッセージセンター取得
        var messageCenter = this.$store.getters.messageCenter;
        // イベントによりフォーカスロックを外す
        messageCenter.subscribe(this, "unlock_text_editor_focus", (param) => { this.isFocusLock = false; });
    }

    destroyed()
    {
        // メッセージセンター取得
        var messageCenter = this.$store.getters.messageCenter;
        // 購読の削除
        messageCenter.unsubscribe(this, "unlock_text_editor_focus");
    }

    private onBlur()
    {
        this.changeInputMode(0);

        this.$nextTick(()=>
        { 

            // フォーカスロック中なら再フォーカスする
            if(this.isFocusLock)
            {
                var textarea = this.$refs.textarea as HTMLTextAreaElement;
                if(textarea != null)
                {
                    textarea.focus();
                    this.onMovePosition();
                }
            }
            
        });

        //キャンバスエリアをスクロールじゃなくて固定にする
            if(UserAgentHelper.getBrowser() == "safari"){
                this.$emit("unfixCanvasArea")
            }
        
    }

    private onFocus()
    {
        this.changeInputMode(1);
        
        // フォーカスをロックする
        this.isFocusLock = true;

        this.onMovePosition();

        //キャンバスエリアをスクロールじゃなくて固定にする
        if(UserAgentHelper.getBrowser() == "safari"){
            this.$emit("fixCanvasArea")
        }
        
    }

    private get innerText()
    {
        if(this.layer instanceof TextLayer)
        {
            return this.layer.text;
        }

        return "";
    }

    private set innerText(innerText)
    {
        // nothing
    }

    // キー押下イベント
    // 縦書きの場合のカーソルキーの移動を変更
    // 選択範囲の作成方向を保持 true: 順方向 false: 逆方向
    private selectionDirectionForward = false; 
    private onKeydown(event : KeyboardEvent)
    {

        this.$emit("preventScroll")

        // 縦書き以外ではなにもしない
        if(!this.isVertical) { return; }

        // テキストエリア取得
        var textarea = this.$refs.textarea as HTMLTextAreaElement;
        if(textarea == null) { return; }

        if(event.keyCode == 37 || event.keyCode == 38 || event.keyCode == 39 || event.keyCode == 40)
        {
            // カーソルキー

            // デフォルトイベントを発行しない
            event.preventDefault();

            // 終端
            var end = textarea.value.length;
            // 今選択中かどうか
            var isSelect = textarea.selectionStart != textarea.selectionEnd;

            // 新しい開始位置
            var newStart = textarea.selectionStart;
            // 新しい終了位置
            var newEnd = textarea.selectionEnd;

            if(event.keyCode == 38 || event.keyCode == 39)
            {
                // 上,右
                if(event.shiftKey)
                {
                    // シフト押下中
                    if(isSelect)
                    {
                        if(this.selectionDirectionForward)
                        {
                            // 選択範囲の縮小
                            newEnd--;
                            if(newEnd < newStart) { newStart = newEnd; }
                        }
                        else
                        {
                            // 選択範囲の拡大
                            newStart--;
                        }
                    }
                    else
                    {
                        // 新しく選択範囲を作成
                        newStart--;
                        this.selectionDirectionForward = false;
                    }
                }
                else
                {
                    if(isSelect)
                    {
                        // 選択解除して選択範囲の先頭へ
                        newEnd = newStart;
                    }
                    else
                    {
                        // 1つ前へ
                        newStart--;
                        newEnd--;
                    }
                }
            }
            else if(event.keyCode == 40 || event.keyCode == 37)
            {
                // 下,左
                if(event.shiftKey)
                {
                    // シフト押下中
                    if(isSelect)
                    {
                        if(this.selectionDirectionForward)
                        {
                            // 選択範囲の拡大
                            newEnd++;
                        }
                        else
                        {
                            // 選択範囲の縮小
                            newStart++;
                            if(newEnd < newStart) { newEnd = newStart; }
                        }
                    }
                    else
                    {
                        // 新しく選択範囲を作成
                        newEnd++;
                        this.selectionDirectionForward = true;
                    }
                }
                else
                {
                    if(isSelect)
                    {
                        // 選択解除して選択範囲の終端へ
                        newStart = newEnd;
                    }
                    else
                    {
                        // 1つ次へ
                        newStart++;
                        newEnd++;
                    }
                }
            }

            // 選択状態更新
            newStart = MathHelper.clamp(newStart, 0, end);
            newEnd = MathHelper.clamp(newEnd, 0, end);
            textarea.setSelectionRange(newStart, newEnd);
        }
    }

    // テキスト変更時のイベント
    private onChangeText()
    {
        // レイヤーのテキストを手動更新する
        var textarea = this.$refs.textarea as HTMLTextAreaElement;
        if(textarea != null)
        {
            this.$emit("changeText", textarea.value);
        }
    }

    // ポジション移動時のイベント
    private onMovePosition()
    {
        var textarea = this.$refs.textarea as HTMLTextAreaElement;
        if(textarea != null)
        {
            this.layer.lastStartPosition = this.layer.startPosition;
            this.layer.lastEndPosition = this.layer.endPosition;
            this.layer.startPosition = textarea.selectionStart;
            this.layer.endPosition = textarea.selectionEnd;
        }
    }

    private get style()
    {
        return { 
            position : "fixed",
            left : "0",
            top : "0",
            width : "10px",
            height : "auto",
            transform : "translate(-10px, 0px)",
        };
    }

    private getX()
    {
        return (this.layer.x * this.scale + this.offsetX) * this.scaleFromSvg;
    }

    private getY()
    {
        return (this.layer.y * this.scale + this.offsetY) * this.scaleFromSvg;
    }

    // 入力にフォーカスする
    public focus()
    {
        // マウント前の可能性があるので、遅延実行
        this.$nextTick(function()
        {
            var textarea = this.$refs.textarea as HTMLTextAreaElement;
            if(textarea != null)
            {
                textarea.focus();
                this.onMovePosition();
            }
        });
    }
}
